import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import NotFound from "./views/NotFound";

Vue.use(Router);

const defaultTitle = 'ONiAd - Certificación';

const routes = [
    {
        path: '/',
        name: 'home',
        component: Home,
        meta: {
            title: 'Home'
        }
        //   meta: {
        //     title: 'ONiAd - Certificación',
        //     metaTags: [
        //       {
        //         name: 'description',
        //         content: 'The about page of our example app.'
        //       },
        //       {
        //         property: 'og:description',
        //         content: 'The about page of our example app.'
        //       }
        //     ]
    },
    // {
    //   path: '/course/:id',
    //   name: 'course',
    //   component: () => import(/* webpackChunkName: "about" */ './views/Course.vue')
    // },
    {
        path: '/course/:courseSlug/certificate/request',
        name: 'certificateRequest',
        component: () => import(/* webpackChunkName: "about" */ './views/CertificateRequest.vue'),
        meta: {
            title: 'Envío acceso certificado'
        }
    },
    {
        path: '/course/:courseSlug/certificate/:token/start',
        name: 'certificateStart',
        component: () => import(/* webpackChunkName: "about" */ './views/CertificateStart.vue'),
        meta: {
            title: 'Obtener certificado'
        }
    },
    {
        path: '/course/:courseSlug/certificate/:token/test',
        name: 'test',
        component: () => import(/* webpackChunkName: "about" */ './views/Test.vue'),
        meta: {
            title: 'Test'
        }
    },
    {
        path: '/course/:idTest/certificate/:idAttemp/certificate',
        name: 'certificate',
        component: () => import(/* webpackChunkName: "about" */ './views/Certificate.vue'),
        meta: {
            title: 'Certificado'
        }
    },
    {
        path: '/course/:courseSlug/temary/:slug?',
        name: 'temary',
        component: () => import(/* webpackChunkName: "about" */ './views/Temary.vue'),
        meta: {
            title: 'Temario'
        }
    },
    {
        path: '/excelTestQuestionsJson',
        name: 'excelToJson',
        component: () => import(/* webpackChunkName: "about" */ './views/ExcelToJson.vue')
    },
    {
        path: '/prueba/:id',
        name: 'sse',
        component: () => import(/* webpackChunkName: "about" */ './views/sse.vue')
    },
    {
        path: '/courses',
        name: 'courses',
        component: () => import(/* webpackChunkName: "about" */ './views/Course.vue'),
        title: 'Cursos'
    },
    {path: '/404', component: NotFound},
    {path: '*', redirect: '/404'},
];
const router = new Router({
    routes,
    base: process.env.BASE_URL,
    mode: 'history',
    scrollBehavior (to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return { x: 0, y: 0 }
        }
    }

});


// This callback runs before every route change, including on page load.
router.beforeEach((to, from, next) => {
    // This goes through the matched routes from last to first, finding the closest route with a title.
    // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
    const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);

    // Find the nearest route element with meta tags.
    const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);
    const previousNearestWithMeta = from.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

    // If a route with a title was found, set the document (page) title to that value.
    if (nearestWithTitle) {
        document.title = `${defaultTitle} | ${nearestWithTitle.meta.title}`;
    } else {
      document.title = defaultTitle;
    }

    // Remove any stale meta tags from the document using the key attribute we set below.
    Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el));

    // Skip rendering meta tags if there are none.
    if (!nearestWithMeta) return next();

    // Turn the meta tag definitions into actual elements in the head.
    nearestWithMeta.meta.metaTags.map(tagDef => {
        const tag = document.createElement('meta');

        Object.keys(tagDef).forEach(key => {
            tag.setAttribute(key, tagDef[key]);
        });

        // We use this to track which meta tags we create, so we don't interfere with other ones.
        tag.setAttribute('data-vue-router-controlled', '');

        return tag;
    })
    // Add the meta tags to the document head.
        .forEach(tag => document.head.appendChild(tag));

    next();
});

export default router;